<template>
  <dividends-page v-if="dividends === true"
                  :sale="sale"
                  @dividends-page-status="setDividendsPage($event)"
  ></dividends-page>
  <div class="sale-details md-layout md-gutter" v-else-if="this.sale && this.token">

          <div class="md-layout-item md-size-50 md-small-size-100">

            <div class="container sale-details__media text_margin">
              <div class="sale-details__media-wrap" v-if="sale.youtube_video_id">
                <iframe
                  :src="embedVideoUrl"
                  frameborder="0"
                  style="width: 100%; height: 100%; border-radius: 16px"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
              </div>

              <div class="sale-details__media-wrap" v-else-if="sale.image">
                <img class="sale-details__image"
                     :src="sale.image"
                     alt="image">
              </div>

            </div>

            <sale-tabs class="sale-details__tabs"
                       id="saleTabs"
                       :sale="sale"
                       :description="description"
                       :syndicate="syndicate"
                       :token="token"
                       :curTab="curTab"
                       @dividends-page-status="setDividendsPage($event)"
            />

          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">

            <div class="container container_30 text_margin sale-details__finance">

              <div class="finance-header text_x_small">
                <div class="finance-header__back">
                  <router-link to='/sales/explore' class="back-btn">
                    <md-icon md-src="/static/img/arrow_back.svg"></md-icon>
                    {{ i18n.sale_back_to_list() }}
                  </router-link>
                </div>
                <div class="finance-header__status">
                  <span v-if="sale.state === 'canceled'"><md-icon md-src="/static/img/cancel_icon.svg"/></span>
                  <span v-if="sale.state === 'closed'"><md-icon md-src="/static/img/cancel_icon.svg"/></span>
                  <span v-if="sale.state === 'open'"><md-icon md-src="/static/img/pending_icon.svg"/></span>
                  <span>
                    <span v-if="sale.state === 'open'">{{ sale.daysToEnd === 0 ? i18n.sale_ends_today() : i18n.sale_to_end({days: sale.daysToEnd}) }} </span>
                    <span v-else>{{ i18n.com_campaign() }} {{ saleStatus }}</span>
                  </span>
                </div>
              </div>

              <div class="finance__project-info">
                <div class="finance__project-info-name text_x_large">{{ sale.name }} ({{ sale.baseAsset }})</div>
                <div class="finance__project-info-type text_x_small">{{ saleType }}</div>
              </div>

              <div class="finance__card-progress card-progress">
                <div class="card-progress__stats text_small">
                  <div v-if="profitability">
                    <md-icon md-src="/static/img/grow_up_icon.svg"></md-icon>
                    <div class="text_small">{{ profitability }}</div>
                  </div>
                  <div>
                    <md-icon md-src="/static/img/man_icon.svg"></md-icon>
                    <div class="text_small">{{ sale.investors }}</div>
                  </div>
                </div>
                <div class="card-progress__bar">
                  <div class="progress-line" :style="`width: ${progress}%`"></div>
                </div>
                <div class="card-progress__amounts">
                  <div class="text_medium text_bold text_active">{{ assetIcon(sale.defaultQuoteAsset) }} {{ roundCurrency(sale.currentCap, sale.defaultQuoteAsset) }} </div>
                  <div class="text_medium text_bold card__goal-amount">{{ assetIcon(sale.defaultQuoteAsset) }} {{ roundCurrency(sale.hardCap, sale.defaultQuoteAsset) }}</div>
                </div>
              </div>

              <div class="finance__actions">
                <div v-if="isOwner" class="btn-wrap space-between margin-top">
                  <md-button v-on:click="tab('Updates')" class="btn md-primary">
                    {{ i18n.sale_add_update_bt() }}
                  </md-button>
                  <md-button v-on:click="tab('Documents')" class="btn md-primary">
                    {{ i18n.sale_upload_document_bt() }}
                  </md-button>
                </div>

                <sale-invest v-else @onChangeCamapignData="loadDetails" :sale="sale"/>
              </div>

            </div>


            <div class="container container_30 sale-details__history">
              <sale-chart class="sale-details__information-item" :sale="sale" />
            </div>



            <!--<div class="md-layout md-gutter md-alignment-center-space-between">
              <div class="md-layout-item md-size-50 t-left bar-collected">
                <p>{{ i18n.sale_collected() }}</p>
                <span>{{ i18n.c(sale.currentCap) }} {{ sale.defaultQuoteAsset }}</span>
              </div>
              <div class="md-layout-item md-size-50 t-right bar-purpose">
                <p>{{ i18n.sale_purpose_collection() }}</p>
                <span>{{ i18n.c(sale.hardCap) }} {{ sale.defaultQuoteAsset }}</span>
              </div>
              <div class="md-layout-item md-size-100">
                <md-progress-bar class="md-accent progress-purpose" md-mode="determinate" :md-value="sale.currentCapProc"></md-progress-bar>
              </div>
            </div>

            <div class="info-table">
              <div class="row">
                <div>{{ i18n.sale_remains_to_collect() }}</div>
                <div><strong>{{ roundCurrency(sale.finishCap.toPrecision(6), sale.defaultQuoteAsset) }} {{ sale.defaultQuoteAsset }}</strong></div>
              </div>
              <div class="row">
                <div>{{ i18n.sale_until_the_end() }}</div>
                <div v-if="sale.state === 'canceled' || sale.state === 'closed'"><strong>{{ saleStatus }}</strong></div>
                <div v-else><strong>{{ i18n.hd(sale.secondsToEnd) }}</strong></div>
              </div>
            </div>

            <div class="info-table">
              <div class="row">
                <div>
                  {{ i18n.sale_campaign_type() }} <md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_campaign_type() }}</md-tooltip></md-icon></div>
                <div><strong>{{ saleType }}</strong></div>
              </div>
&lt;!&ndash;              <div class="row">&ndash;&gt;
&lt;!&ndash;                <div>* {{ i18n.sale_sales_share() }} <md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_sales_share() }}</md-tooltip></md-icon></div>&ndash;&gt;
&lt;!&ndash;                <div><strong>20%</strong></div>&ndash;&gt;
&lt;!&ndash;              </div>&ndash;&gt;
              <div class="row" v-if="sale.type !== 'crowdfunding'">
                <template v-if="sale.type === 'equity'">
                <div>{{ i18n.sale_profitability() }} <md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_profitability() }}</md-tooltip></md-icon></div>
                <div v-if="sale.profitability_from && sale.profitability_to"><strong>от {{ sale.profitability_from }} до {{ sale.profitability_to }}%</strong></div>
                <div v-else><strong>-</strong></div>
                </template>
                <template v-if="sale.type === 'deposit'">
                <div>{{ i18n.sale_fixed_annual_arrive() }} <md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_profitability() }}</md-tooltip></md-icon></div>
                <div><strong>{{ sale.annualPercentage }}%</strong></div>
                </template>
              </div>
&lt;!&ndash;              <div class="row">&ndash;&gt;
&lt;!&ndash;                <div>{{ i18n.sale_campaign_duration() }}<md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_campaign_duration() }}</md-tooltip></md-icon></div>&ndash;&gt;
&lt;!&ndash;                <div><strong>{{ i18n.hd(sale.daysCampaignDuration) }}</strong></div>&ndash;&gt;
&lt;!&ndash;              </div>&ndash;&gt;
&lt;!&ndash;              <div class="row">&ndash;&gt;
&lt;!&ndash;                <div>* {{ i18n.sale_minimum_investment() }} <md-icon class="info">info <md-tooltip :class="'info-tooltip'" md-direction="bottom">{{ i18n.sale_minimum_investment() }}</md-tooltip></md-icon></div>&ndash;&gt;
&lt;!&ndash;                <div><strong>$ 250</strong></div>&ndash;&gt;
&lt;!&ndash;              </div>&ndash;&gt;
            </div>-->
          </div>

  </div>
</template>

<script>
  import { salesService } from '@api/sales.service'
  import { tokensService } from '@api/tokens.service'
  import { SaleRecord } from '@js/records/sale.record'
  import { TokenRecord } from '@js/records/token.record'
  import { i18n } from '@js/i18n'

  import SaleChart from './components/Sales.Chart'
  import SaleInvest from './components/Sales.Invest'
  import SaleTabs from './Sales.Tabs'
  import InvestProgressBar from '../to_delete/Sales.ProgressBar'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import DividendsPage from './components/Sales.DividendsPage'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { CurrencyHelper } from '@js/helpers/currency.helper'

  export default {
    name: 'sale-details',
    mixins: [CurrencyRound],
    props: ['id'],
    components: {
      SaleInvest,
      InvestProgressBar,
      SaleTabs,
      SaleChart,
      DividendsPage
    },

    data: _ => ({
      curTab: '',
      sale: '',
      token: '',
      description: '',
      syndicate: {
        email: ''
      },
      i18n,
      dividends: false
    }),
    async created () {
      if (this.id) {
        await this.loadDetails()
      }
    },
    methods: {
      tab (tab) {
        this.curTab = tab
      },
      async loadDetails () {
        this.sale = new SaleRecord(await salesService.loadSaleById(this.id))
        await Promise.all([
          this.token = new TokenRecord(await tokensService.loadTokenByCode(this.sale.baseAsset)),
          this.description = await salesService.loadSaleDescription(this.sale.owner, this.sale.descriptionID)
        ])
        // const syndicateDetails = await salesService.loadSaleOwner(this.sale.owner)
        // this.syndicate = syndicateDetails.syndicateDetails
        // this.syndicate.email = syndicateDetails.syndicateEmail
      },
      youtubeUrl (youTubeVideoId) {
        const query = 'watch?v='
        if (youTubeVideoId.includes(query)) {
          return youTubeVideoId.replace(query, 'embed/')
        }
        return `https://www.youtube.com/embed/${youTubeVideoId}`
      },
      setDividendsPage (status) {
        this.dividends = status
      },
      getTranslate (type) {
        if (type === 'status') {
          return ('lbl_status_' + this.sale.state)
        } else if (type === 'type') {
          return this.sale.details.internal_type ? ('sale_subtype_' + this.sale.details.internal_type) : ('sale_subtype_' + this.sale.details.type)
        }
      },
      assetIcon (asset) {
        return CurrencyHelper.getCurrencyIcon(asset)
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.account,
        vuexTypes.accountId
      ]),
      saleStatus () {
        return i18n[this.getTranslate('status')]()
      },
      saleType () {
        return i18n[this.getTranslate('type')]()
      },
      isOwner () {
        return this.sale.owner === this.accountId
      },
      embedVideoUrl () {
        return this.youtubeUrl(this.sale.youtube_video_id)
      },
      progress () {
        const progress = Math.floor((this.sale.currentCap / this.sale.hardCap) * 100)
        return progress > 100 ? 100 : progress
      }
    }
  }
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .sale-details {
    justify-content: flex-start;
    align-items: flex-start;

    @include respond-to(medium) {
      flex-direction: column;
    }

    &__media {
      width: 100%;
      height: 400px;
      @include respond-to(medium) {
        height: auto;
      }
    }

    &__media-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      overflow: hidden;
      border-radius: 16px;
    }

    &__finance {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 400px;

      & .finance-header {
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        width: 100%;

        & .back-btn {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          text-decoration: none;

          & svg {
            width: 13px;
          }
        }

        &__status {
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;

          & svg {
            width: 14px;
          }
        }
      }

      & .finance__project-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        width: 100%;
        margin: 20px 0 24px;

        &-type {
          color: $col-md-primary;
        }
      }

      & .card-progress {
        flex: 2 2 auto;
        &__amounts {
          display: flex;
          justify-content: space-between;
        }

        &__bar {
          width: 100%;
          height: 8px;
          margin: 10px 0;
          background: $col-md-accent;
          border-radius: 4px;

          & .progress-line {
            height: 100%;
            background: $col-md-primary;
            border-radius: 4px;
          }
        }

        &__stats {
          display: flex;
          justify-content: flex-start;
          text-align: center;

          & div {
            display: flex;
            align-items: center;

            &:first-child {
              margin-right: 28px;
            }

            & .md-icon {
              margin-right: 12px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/Sales.Details.vue